<template>
  <GlobalHeader theme="dark-green" />
  <main id="content" v-bind="$attrs" ref="parentRef">
    <PageHead :blok="blok" :date="date" :name="name" :slug="slug" />
    <GlobalSection
      class="job-board"
      contained
      :blok="{ theme: 'dark-gray' }"
      :class="[loading && 'job-board--loading']"
    >
      <template v-if="searched">
        <template v-if="loading">
          <div class="job-board__intro">
            <CustomHeading :blok="blok.heading[0]" />
            <div class="job-board__dot" />
          </div>
          <div class="job-board__results">
            <div
              v-for="index in Array.from(Array(6))"
              :key="index"
              class="job-board__results-fake"
            >
              <div class="fake-result"></div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="job-board__intro">
            <CustomHeading :blok="blok.heading[0]" />
            <div class="job-board__utility">
              <select v-model="selectedState" class="job-board__select">
                <option disabled value="">State</option>
                <option v-for="state in states" :key="state" :value="state">
                  {{ state }}
                </option>
              </select>
              <select
                id="city"
                v-model="selectedCity"
                class="city-select"
                :disabled="selectedState === ''"
              >
                <option disabled value="">City</option>
                <option v-for="city in cities" :key="city" :value="city">
                  {{ city }}
                </option>
              </select>
              <select
                id="specialty"
                v-model="specialty"
                class="job-board__select"
                type="select"
                name="specialty"
              >
                <option disabled value="">What's Your Specialty?</option>
                <option value="">Show all specialties</option>
                <option value="CNA">Certified Nursing Aide</option>
                <option value="LPN">Licensed Practical Nurse</option>
                <option value="LVN">Licensed Vocational Nurse</option>
                <option value="RN">Registered Nurse</option>
                <option value="RT">Respiratory Therapist</option>
                <option value="PT">Physical Therapist</option>
                <option value="PTA">Physical Therapist Assistant</option>
                <option value="OT">Occupational Therapist</option>
                <option value="OTA">Occupational Therapist Assistant</option>
                <option value="SLP">Speech Language Pathology</option>
                <option value="DH">Dental Hygienist</option>
                <option value="DA">Dental Assistant</option>
                <option value="CG">Caregiver</option>
                <option value="RA-CBRF">CBRF Aide</option>
                <option value="LNA">Licensed Nursing Assistant</option>
                <option value="CMA">Certified Medication Aide</option>
                <option value="CMT">Certified Medication Tech</option>
                <option value="QMA">Qualified Medication Aide</option>
              </select>
              <button
                :disabled="selectedState === '' || selectedCity === ''"
                :class="{
                  'disabled-submit':
                    selectedState === '' || selectedCity === '',
                }"
                @click="runSearch"
              >
                Search
              </button>
              <div class="flex flex-row-reverse gap-x-2">
                <div class="hidden md:block">
                  <CTAGroup
                    v-if="blok.links && blok.links.length > 0"
                    class="h-[50px]"
                    :ctas="blok.links"
                  />
                </div>
              </div>
            </div>
            <div class="md:hidden block md:mt-none mt-4">
              <CTAGroup
                v-if="blok.links && blok.links.length > 0"
                class="h-[50px]"
                :ctas="blok.links"
              />
            </div>
          </div>
          <div class="job-board__results">
            <JobPosting
              v-for="post in filteredJobPosts"
              :key="post.role_id"
              :posting="post"
            />
            <CTAGroup
              v-if="blok.links && blok.links.length > 0"
              class="bottom-cta"
              :ctas="blok.links"
            />
            <p
              class="job-board__load-more"
              :class="{ 'no-results': noResults }"
              @click="loadMore"
            >
              Load More
            </p>
          </div>
        </template>
      </template>
      <template v-else>
        <div class="job-board__intro">
          <CustomHeading :blok="blok.heading[0]" />
          <div class="job-board__utility">
            <select v-model="selectedState" class="job-board__select">
              <option disabled value="">State</option>
              <option v-for="state in states" :key="state" :value="state">
                {{ state }}
              </option>
            </select>
            <select
              id="city"
              v-model="selectedCity"
              class="city-select"
              :disabled="selectedState === ''"
            >
              <option disabled value="">City</option>
              <option v-for="city in cities" :key="city" :value="city">
                {{ city }}
              </option>
            </select>
            <select
              id="specialty"
              v-model="specialty"
              class="job-board__select"
              type="select"
              name="specialty"
            >
              <option disabled value="">What's Your Specialty?</option>
              <option value="">Show all specialties</option>
              <option value="CNA">Certified Nursing Aide</option>
              <option value="LPN">Licensed Practical Nurse</option>
              <option value="LVN">Licensed Vocational Nurse</option>
              <option value="RN">Registered Nurse</option>
              <option value="RT">Respiratory Therapist</option>
              <option value="PT">Physical Therapist</option>
              <option value="PTA">Physical Therapist Assistant</option>
              <option value="OT">Occupational Therapist</option>
              <option value="OTA">Occupational Therapist Assistant</option>
              <option value="SLP">Speech Language Pathology</option>
              <option value="DH">Dental Hygienist</option>
              <option value="DA">Dental Assistant</option>
              <option value="CG">Caregiver</option>
              <option value="RA-CBRF">CBRF Aide</option>
              <option value="LNA">Licensed Nursing Assistant</option>
              <option value="CMA">Certified Medication Aide</option>
              <option value="CMT">Certified Medication Tech</option>
              <option value="QMA">Qualified Medication Aide</option>
            </select>
            <button
              :disabled="selectedState === '' || selectedCity === ''"
              :class="{
                'disabled-submit': selectedState === '' || selectedCity === '',
              }"
              @click="runSearch"
            >
              Search
            </button>
            <CTAGroup
              v-if="blok.links && blok.links.length > 0"
              :ctas="blok.links"
            />
          </div>
        </div>
      </template>
    </GlobalSection>
  </main>
  <GlobalFooter />
</template>

<script lang="ts" setup>
import { CustomHeadingBlokProps, JobBoardBlokProps } from '@/types';
import { PostingResult } from '@/composables/getShifts';
import { getStates, getCities, getJobs } from '@/composables/getJobs';

// Props
defineProps<{
  blok: JobBoardBlokProps;
  date: string;
  name: string;
  slug: string;
}>();

// grab any initial parameters
// to support any initial filtering and pagination
const route = useRoute();
const router = useRouter();
const selectedState = ref('');
const selectedCity = ref('');
const specialty = ref('');
const searched = ref<boolean>(false);
const loading = ref<boolean>(false);
const filteredJobPosts = ref<PostingResult[]>([]);
const jobData = ref<PostingResult[]>([]);
const states: string[] = await getStates();
const cities = ref<string[]>([]);
const noResults = ref<boolean>(true);
// per page
const perPage = 3;
// current page
const page = ref<number>(1);

watch(selectedState, async (newState) => {
  if (newState === '') {
    cities.value = [];
  } else {
    cities.value = await getCities(newState);
  }
});

const runSearch = async () => {
  loading.value = true;
  const jobResponse = await getJobs(
    selectedState.value,
    selectedCity.value,
    specialty.value
  );
  const query: { [key: string]: string | undefined } = {
    state: selectedState.value,
    city: selectedCity.value,
  };

  if (specialty.value !== '') {
    query.job_role = specialty.value;
  }
  router.push({
    query,
  });
  jobData.value = jobResponse;

  console.log('jobData ' + jobData);
  if (jobData.value.length > 0) {
    jobData.value.forEach((job: PostingResult) => {
      if (job.description) {
        job.description =
          'Build your own schedule. Take control of your career. Looking for ' +
          job.job_role +
          " jobs that fit your life? If you're tired of having no control over your schedule or just want to earn more money, PRN shifts could be what you're looking for!";
      }
    });
    filteredJobPosts.value = jobData.value.slice(0, perPage);
    console.log('jobData length ' + jobData.value.length);
    if (jobData.value.length > perPage) {
      noResults.value = false;
    } else {
      noResults.value = true;
    }

    console.log('filter' + filteredJobPosts.value);
  } else {
    filteredJobPosts.value = jobData.value;
    console.log('elseing');
    noResults.value = true;
  }
  loading.value = false;
  searched.value = true;
};

const loadMore = () => {
  console.log('Before: ' + page.value);
  const start = page.value * perPage;
  const end = start + perPage;
  console.log('start: ' + start);
  console.log('end: ' + end);
  console.log('Jobdata slice ' + jobData.value.slice(start, end));
  filteredJobPosts.value.push(...jobData.value.slice(start, end));
  if (jobData.value.slice((page.value + 1) * perPage, end).length === 0) {
    console.log('no more results');
    noResults.value = true;
  }
  page.value += 1;
  console.log('After: ' + page.value);
};

console.log(route.query);
if (route.query.state && states.includes(route.query.state as string)) {
  selectedState.value = route.query.state as string;
  cities.value = await getCities(selectedState.value);
  if (route.query.city && cities.value.includes(route.query.city as string)) {
    selectedCity.value = route.query.city as string;
  }
  if (route.query.job_role) {
    const specialties = [
      'nl',
      'CNA',
      'LPN',
      'LVN',
      'RN',
      'RT',
      'PT',
      'PTA',
      'OT',
      'OTA',
      'SLP',
      'DH',
      'DA',
      'CG',
      'RA-CBRF',
      'LNA',
      'CMA',
      'CMT',
      'QMA',
    ];
    if (specialties.includes(route.query.job_role as string)) {
      specialty.value = route.query.job_role as string;
    }
  }
  await runSearch();
}

// parent html reference
const parentRef = ref();

const isFirefox = ref();

onMounted(() => {
  // Firefox has a bug with vector-effect="non-scaling-stroke, so is being excluded. Nothing about the effect is broken, just that the stroke width will slightly scale based on the length of the word.
  isFirefox.value = navigator.userAgent.match(/firefox|fxios/i);
});
</script>

<style lang="scss">
.job-board {
  @keyframes small-pulse {
    0% {
      transform: scale(1);
    }

    50% {
      transform: scale(1.02);
    }

    100% {
      transform: scale(1);
    }
  }

  @keyframes large-pulse {
    0% {
      transform: scale(1);
    }

    50% {
      transform: scale(1.2);
    }

    100% {
      transform: scale(1);
    }
  }

  .disabled-submit {
    background-color: var(--neutral-2);
    border-color: var(--neutral-2);
    cursor: not-allowed;
  }

  &__intro {
    @include container;

    margin-block-end: 40px;
    padding-block-end: 0;
    padding-block-start: 80px;

    // taken from intro
    .custom-heading {
      max-width: 660px;
      width: 100%;
    }
  }

  &__utility {
    align-items: flex-end;
    display: flex;
    gap: 8px;
    justify-content: space-between;
    margin-block-start: var(--spacing-s);
    padding: var(--spacing-l);
    background-color: var(--chalk);
    border-radius: 18px 18px 18px 0px;
    background-image: url('/img/textures/texture-3.png');

    input {
      background-color: transparent;
      border: 1px solid var(--neutral);
      color: var(--dark-gray);
      border-radius: 2px;
      min-height: 51px;
      padding-block: 12px;
      padding-inline: 5px;
      width: 100%;
      &:focus {
        outline: none;
      }
      &:focus-visible {
        border-width: 2px;
      }
      &::placeholder {
        color: var(--dark-gray);
      }
    }
    button {
      @include primary-button;
      color: var(--chalk);
      border: 1px solid var(--dark-gray);
      background-color: var(--dark-gray);
      height: 51px;
    }
  }

  @media all and #{$mq-s-max} {
    &__utility {
      flex-direction: column;
      gap: 8px;
      padding-block: var(--spacing-l);

      button {
        width: 100%;
      }
    }
  }

  &__select {
    width: 100%;
    max-width: fit-content;
    background: transparent;
    height: 51px;
    overflow: hidden;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding-left: 5px;
    padding-right: 5px;
    margin-block-start: 0.875rem !important;
    color: var(--dark-gray);
    border: 1px solid var(--neutral);
  }

  .city-select {
    background-color: transparent;
    border: 1px solid var(--neutral);
    color: var(--dark-gray);
    border-radius: 2px;
    min-height: 51px;
    padding-block: 12px;
    padding-inline: 5px;
    width: 100%;
    &:focus {
      outline: none;
    }
    &:focus-visible {
      border-width: 2px;
    }
    &::placeholder {
      color: var(--dark-gray);
    }
  }

  @media all and #{$mq-s-max} {
    &__select {
      width: 100%;
      max-width: none;
    }
  }

  &__results {
    --column-count: 1;

    @include container;

    display: grid;
    grid-gap: 24px;
    grid-template-columns: repeat(var(--column-count), 1fr);
  }

  &__load-more {
    cursor: pointer;
    text-decoration: underline;
    text-underline-offset: 6px;
    font-weight: 500;
    line-height: 1.5;
    margin-block-start: 24px;
    text-align: center;
  }

  .no-results {
    display: none;
  }

  &__results-fake {
    .fake-result {
      width: 100%;
      height: 208px;
      background-color: var(--chalk);
      border-radius: 18px;
    }
  }

  &__dot {
    animation: large-pulse 1600ms infinite;
    background-color: var(--neutral-4);
    border-radius: 100%;
    flex-shrink: 0;
    height: 32px;
    margin-inline-start: 16px;
    width: 32px;
  }

  .pagination {
    @include container;

    margin-block-start: calc(var(--spacing-m) * -1);
    padding-block-start: 0;
  }

  &--loading {
    .job-board {
      &__results {
        padding-block-end: var(--spacing-xxl);
        position: relative;

        &::before {
          background: linear-gradient(
            0deg,
            #f2f3f5 0%,
            rgb(242 243 245 / 0%) 100%
          );
          content: '';
          height: 400px;
          inset-block-end: -5px;
          position: absolute;
          width: 100%;
          z-index: 1;
        }

        @for $i from 2 through 6 {
          .job-board__results-fake:nth-child(#{$i}n) {
            animation-delay: #{$i * 100}ms;
          }
        }

        &-fake {
          animation: small-pulse 1600ms infinite;
        }
      }
    }
  }
}

.bottom-cta {
  .cta-group {
    align-items: center;
    justify-content: center;
    margin-block-start: calc(var(--spacing-l) - 10px);

    .cta {
      min-width: 142px;
    }
  }
}
</style>
